import { useAuth } from "../../context/AuthProvider";
import { useCallback } from "react";

const MIN_VALIDITY = Number(process.env.REACT_APP_MIN_VALIDITY_TOKEN) || 30;
const BASE_URL = process.env.REACT_APP_URL_BEONE_API || "https://api.be-one.fr/api";

export const useAuthenticatedFetch = () => {
    const { keycloakInstance } = useAuth();

    const authFetch = useCallback(async (endpoint: string, options: RequestInit = {}) => {
        if (!keycloakInstance?.authenticated) {
            throw new Error("User not authenticated.");
        }

        try {
            // N'appelle updateToken que si le token expire dans moins de MIN_VALIDITY secondes
            const expiry = (keycloakInstance.tokenParsed?.exp ?? 0) - Date.now() / 1000;
            if (expiry < MIN_VALIDITY) {
                await keycloakInstance.updateToken(MIN_VALIDITY);
            }

            const isFormData = options.body instanceof FormData;
            const headers: Record<string, string> = {
                ...(!isFormData && { "Content-Type": "application/json" }),
                "Accept": "application/json",
                ...(options.headers as Record<string, string>),
                Authorization: `Bearer ${keycloakInstance.token}`,
            };

            const response = await fetch(BASE_URL + endpoint, { ...options, headers });

            if (response.ok) {
                if (response.status === 204) return { success: true };
                if (headers.Accept === "application/pdf") return response.blob();
                return response.json();
            }

            const errorBody = await response.text();
            throw new Error(`HTTP ${response.status} ${response.statusText}: ${errorBody}`);
        } catch (error) {
            console.error("API error:", error);
            if (error instanceof Error && (error.message.includes("401") || error.message.includes("User not authenticated"))) {
                keycloakInstance.login();
            }
            throw error;
        }
    }, [keycloakInstance]);

    return authFetch;
};